/* Angular Modules */
import {Injectable} from '@angular/core';
/* External Libraries */
import {LocalStorage} from '@ngx-pwa/local-storage';
/* Local Models */
import {Activity} from '@shared/models/activity';
import {Notification} from '@shared/models/notification';

@Injectable()
export class LoggingService {
  activities: Activity[] = [];

  notifications: Notification[] = [];

  constructor(
    private localStorage: LocalStorage) {
  }

  public logActivity(activity: Activity): void {
    activity.Id = this.activities.length + 1;
    this.activities.push(activity);
    this.localStorage.setItem('activity', this.activities)
      .subscribe(() => {
        console.log("activity Logged");
      });
  }

  public logNotification(notification: Notification): void {
    notification.Id = this.notifications.length + 1;
    this.notifications.push(notification);
    this.localStorage.setItem('notification', this.notifications)
      .subscribe(() => {
        console.log("notification Logged");
      });
  }

  public clearAll(): void {
    this.localStorage.clear().subscribe((result) => {
      console.log(result);
    });
    this.clearActivities();
    this.clearNotifications();
  }

  public clearActivities(): void {
    this.localStorage.removeItem('activity');
    this.loadActivities();
  }

  public clearNotifications(): void {
    this.localStorage.removeItem('notification');
    this.loadNotifications();
  }

  public clearNotification(id: number): void {
    const index = this.notifications.findIndex(x => x.Id === id);
    this.notifications.splice(index, 1);
  }

  public readNotifications(): Notification[] {
    return this.notifications;
  }

  public readActivities(): Activity[] {
    return this.activities;
  }

  public getActivities(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.localStorage.getItem('activity').subscribe(data => {
        if (data != null) {
          this.activities = data;
        }
        resolve(this.activities);
      });
    });
  }

  public getNotifications(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.localStorage.getItem('notification').subscribe(data => {
        if (data != null) {
          this.notifications = data;
        }
        resolve(this.notifications);
      });
    });
  }

  private loadActivities(): void {
    this.activities = [];
    this.localStorage.getItem('activity').subscribe((data) => {
      if (data != null) {
        this.activities = data;
      }
    });
  }

  private loadNotifications(): void {
    this.notifications = [];
    this.localStorage.getItem('notification').subscribe((data) => {
      if (data != null) {
        this.notifications = data;
      }
    });
  }
}
